<mat-toolbar class="main-toolbar">
  <h1 class="toolbar-title">{{ toolbarTitle$ | async }}</h1>
  @if (prid$ | async; as prid) {
    <button
      class="account-button"
      mat-icon-button
      aria-label="Account profile"
      data-testid="toolbar-account-btn"
    >
      <img
        class="account-avatar"
        [src]="getProfileImageUrl(prid)"
        alt="Profile"
      />
    </button>
  }
</mat-toolbar>
